export const colors = [
    "#8b2fd6",
    "#2b7966",
    "#3a85d7",
    "#d3e404",
    "#2f3da2",
    "#e5278c",
    "#9a6a35",
    "#de3fa6",
    "#ab50ad",
    "#58509e",
    "#ab1eb3",
    "#b98d4e",
    "#98a2d1",
    "#1d7f62",
    "#6c2eb4",
    "#9356f7",
    "#f6fcd8",
    "#a46dc9",
    "#2f5ab0",
    "#d05b28",
    "#7f6ec5",
    "#db5e63",
    "#cb8538",
    "#5e5b5f",
    "#4f9ef9",
    "#9e7585",
    "#d6e9d5",
    "#b93f34",
    "#7a904d",
    "#56abaf",
    "#f8d893",
    "#9bcfa7",
    "#5d38cd",
    "#df5f0d",
    "#14c561",
    "#b1c999",
    "#e4d971",
    "#4c1ea2",
    "#f31a8d",
    "#6942a1",
    "#f5a9ec",
    "#4f76ea",
    "#d79847",
    "#606d26",
    "#05d1e8",
    "#3f3d27",
    "#1e833d",
    "#26a15d",
    "#cf8f22",
    "#4f20eb",
    "#5ab9f0",
];